import Player, { PlayerProps } from './Player';

export default Player;
export type { PlayerProps };
